document.addEventListener("DOMContentLoaded", initialiseDiscountField );
document.addEventListener("refreshPromoField", initialiseDiscountField );

function initialiseDiscountField() { 
  console.log("INIT DISCOUNT FIELD");
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  let discountCodeSuccessMessage = document.querySelector(".discount-code-success");
  let discountCodeErrorContainer = document.querySelector('.discount-code-error-container');
  let discountCodeSavings = document.querySelector('.discount-code-savings');
  let discountCodeIndicator = document.querySelector(".discount-code-indicator");
  let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code-input");
  let automaticDiscountCode = document.querySelector('#auto-discount-code');

  if(automaticDiscountCode) {
    let title = automaticDiscountCode.getAttribute('data-title');
    if(title) {
      applyDiscount(title);
    }
  }
  else if (localStorage.discountCode) {
    applyDiscount( JSON.parse(localStorage.discountCode).code);
    // document.querySelector(".cart-promo-toggle").classList.add("hide");
    // document.querySelector(".cart-sidebar-discount").classList.add("show");
  }

  if(applyBtn)
    applyBtn.addEventListener("click", function(e){
    e.preventDefault()
    applyDiscount(discountCodeInput.value);
  });

  if(clearBtn)
    clearBtn.addEventListener("click", function(e){
    e.preventDefault()
    clearDiscount();
  });

  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/checkout?discount=%20");
  }

  function clearLocalStorage() {
    if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
    localStorage.removeItem("discountCode");
  }

  function applyDiscount(code) {
    if(applyBtn) {
      applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: code
      })
    })
    .then(function(response) { return response.json() })
    .then(function(cart) {
      console.log("DATA", cart);
      let applicableDiscounts = cart.discount_codes.filter(discount => discount.applicable === true);
      if(cart && applicableDiscounts.length > 0) {
        let currentPromo = cart.discount_codes.find((discount) => {
          return discount.code === code;
        });
        if(!currentPromo) {
          return
        }
        fetch('/cart?view=discount', {})
        .then(function(res){return res.text();})
        .then(function(data) {
          let dataObject = JSON.parse(JSON.stringify(data))
          dataObject = JSON.parse(dataObject)
          console.log(dataObject);
          let appliedPromo = dataObject.discounts.find((discount) => {
            return discount.title.toUpperCase() === code.toUpperCase();
          });
          if(discountCodeWrapper) discountCodeWrapper.style.display = "block";
          if(discountCodeError) discountCodeError.innerHTML = "";
          if(discountCodeValue) discountCodeValue.innerHTML = appliedPromo.title + " (" + appliedPromo.amount + ' ' + Shopify.currency.active + ")";
          if(discountCodeIndicator) discountCodeIndicator.innerHTML = appliedPromo.title;
          if(discountCodeSavings) discountCodeSavings.innerHTML = appliedPromo.amount; 
          if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
          if(discountCodeSuccessMessage) {
            discountCodeSuccessMessage.style.display = 'block';
            document.querySelector(".cart-promo-toggle").classList.add("hide");
            document.querySelector(".cart-sidebar-discount").classList.add("show");
            let cartFullPriceElement = document.querySelector('.cart__summary__original-price-container');
            if(cartFullPriceElement) cartFullPriceElement.classList.remove('hidden');
            // let rewardsLoggedOutMessage = document.querySelector('.login-flow-container');
            // if(rewardsLoggedOutMessage) rewardsLoggedOutMessage.style.display = 'none';
          }

          let localStorageValue = {
            'code': code.trim(),
            'totalCart': data.items_subtotal_price
          };
          localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
          // let totalCartSelector = document.querySelector('.cart__summary-subtotal [data-cart-total]');
          // if(totalCartSelector) totalCartSelector.innerHTML = dataObject.total_price_with_currency;
          
        });
        
      } else {
        if(discountCodeValue) discountCodeValue.innerHTML = "";
        clearLocalStorage();
        if(discountCodeError) {
          discountCodeError.innerText = `Please enter a valid discount code`;
          discountCodeErrorContainer.style.display = 'block';
          discountCodeInput.setAttribute('aria-describedby', discountCodeError.id);
          discountCodeInput.focus();
        } 
      }
    })
    .then(() => {
      let sectionsToUpdate = 'drawer-cart-top,cart-mini-summary'; // comma-separated list of section IDs generated by shopify
      fetch(`?sections=${sectionsToUpdate}`)
      .then((response) => {
        return response.json()
      })
      .then((sectionsData) => {
        let drawerCartTopContainer = document.getElementById('drawer-cart-top').querySelector('.mini-cart-section-dynamic');
        let cartTopSection = sectionsData['drawer-cart-top'];
        drawerCartTopContainer.innerHTML = cartTopSection;
        updateSubtotal(sectionsData['cart-mini-summary']);
        if (typeof initLoopBundle === 'function') initLoopBundle("cartItemss");
      })
    }).finally(function(params) {
      if(applyBtn){
        applyBtn.innerHTML = "APPLY";
        applyBtn.style.pointerEvents = "all";
      }
      // updateRewardPoints();
    });
  }
}

// function updateRewardPoints() {
//   const pointsElement = document.querySelector('.yotpo-spotlight-cta-points');
//   const triggerElements = document.querySelectorAll('.yotpo-custom-spotlight-trigger');

//   if (!pointsElement || triggerElements.length === 0) return;

//   const value = pointsElement.getAttribute('data-original-balance');

//   if (value !== null) {
//     for(let i = 0; i < triggerElements.length; i++) {
//       triggerElements[i].textContent = `You have ${value} points. Click here to view rewards.`;
//       window.YotpoSpotlightObserver.attachTriggerEvent(triggerElements[i]);
//     }
//   }
// }

function hideMessage(e) {
  e.target.closest('.discount-code__message').style.display = 'none';
}

function togglePromoField() {
  // document.querySelector(".cart-promo-toggle").addEventListener("click", function() {
    document.querySelector(".cart-promo-toggle").classList.add("hide"),
    document.querySelector(".cart-sidebar-discount").classList.toggle("show")
  // });
}

function updateSection(sectionData, sectionId) {
  let container = document.getElementById(sectionId).querySelector('.mini-cart-section-dynamic');
  container.innerHTML = sectionData;
}

function updateSubtotal(cartSummaryRawHtml) {
  const totalSelector = '.cart__summary-wrap .cart__summary-row';
  const parser = new DOMParser();
  const cartSummary = parser.parseFromString(cartSummaryRawHtml, 'text/html');
  const newTotal = cartSummary.querySelector(totalSelector).innerHTML;
  document.querySelector(totalSelector).innerHTML = newTotal;
}

function initialiseObserver() {
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById("auto-discount-code");

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: false, subtree: false };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        console.log(`The ${mutation.attributeName} attribute was modified.`);

        if(mutation.attributeName === "data-title") {
          applyDiscount();
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}